'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Textarea = require('./Textarea');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Textarea).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }